import React, { useEffect, useState } from 'react';
import { Link, useLocation } from 'react-router-dom';
import Footer from '../Layout/Footer';
import Header from '../Layout/Header';
import Complaintform from '../../assets/img/complaint_form.png';
import { Button, Form } from 'react-bootstrap';
import * as Yup from 'yup';
import { useFormik } from 'formik';
import { complaintForm, complaintFormTask } from '../../Redux/ComplaintForm/action';
import loader from '../../assets/img/loader.gif';
import ToasterMessage from '../ToasterMessage';
import { useSelector } from 'react-redux';

const ComplaintForm = () => {


    const user = JSON.parse(localStorage.getItem("user"));
    const user_name = localStorage.getItem("user_name");
    // const user = useSelector((state) => state.user)

    const [tasks, setTasks] = useState();

    const [assigntask, setAssignedTask] = useState();
    const [isloader, setIsloader] = useState(false);
    const [toaster, setToaster] = useState("");
    const [showTaskDropdown, setShowTaskDropdown] = useState(true);
    const [selectedTask, setSelectedTask] = useState("1");

    const handleTaskChange = (event) => {
        const value = event.target.value;
        setSelectedTask(value);
        setShowTaskDropdown(value === "1");
    };
    const handletaskCategory = (e) => {
        setAssignedTask(e.target.value)
        formik.setValues({
            ...formik,
            task: e.target.value
        })
    };
    const validationSchema = Yup.object().shape({
        // task: Yup.string()
        //     .required('Required'),
        description: Yup.string()
            .required('Required'),
    });
    const formik = useFormik({
        initialValues: {
            type: "",
            task: "",
            description: "",
        },
        validationSchema,
        validate: (values) => {
            const errors = {}
            if (showTaskDropdown && values.task == "") {
                errors.task = "Required"
            }
            return (errors)
        },
        onSubmit: (values) => {
            setIsloader(true)
            let formData = new FormData();
            // formData.append("type", "");
            formData.append("type", selectedTask);
            formData.append("description", values.description);
            if (selectedTask == "1")
                formData.append("task", assigntask);
            complaintForm({ formData })((response) => {
                if (response && response.status) {
                    setIsloader(false)

                    formik.resetForm();
                    setAssignedTask("")
                    setToaster("Success")
                    setTimeout(() => {
                        setToaster("")

                    }, 2000);
                }
                else {
                    setIsloader(false)
                    setToaster("Error")
                    setTimeout(() => {
                        setToaster("")

                    }, 2000);
                }
            });
        },
    });

    useEffect(() => {
        complaintFormTask()((response) => {
            if (response && response.status) {
                setTasks(response?.data?.data)
            }
        });

    }, []);

    return (
        <React.Fragment>
            <ToasterMessage toaster={toaster} setToaster={setToaster} />
            <Header />
            <section>
                <div className="breadcrumbs">
                    <div className="container">
                        <div className="row">
                            <div className="col-md-12 my-auto">
                                <h1>Complaint Form</h1>
                                <ul className="trail-items">
                                    <li className="trail-item trail-begin">
                                        <Link to="/">
                                            <span itemProp="name">Home</span><i className="bi bi-chevron-double-right"></i>
                                        </Link>
                                    </li>
                                    <li className="trail-item trail-end">
                                        <span itemProp="item"><span itemProp="name">Complaint Form</span></span>
                                    </li>
                                </ul>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <section className='contacts'>
                <div className='container'>
                    <div className='row'>
                        <div className='col-lg-12'>

                            <div className='row'>
                                <div className='col-lg-7'>
                                    <div className="">
                                        <div>
                                            <img src={Complaintform} alt="" className='img-fluid' />
                                        </div>
                                    </div>
                                </div>
                                <div className='col-lg-5'>
                                    <div className="contact-form-wrapper d-flex justify-content-center p-0">
                                        <div className="contact-form">
                                            <h5 className="title">Complaint Form</h5>
                                            <Form onSubmit={formik.handleSubmit} >
                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label>Full Name</Form.Label>
                                                    <Form.Control
                                                        type="text"
                                                        name="first_name"
                                                        value={user_name}
                                                        onChange={formik.handleChange}
                                                        placeholder="Enter full name"
                                                        disabled
                                                    />
                                                </Form.Group>

                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label>Email Address</Form.Label>
                                                    <Form.Control
                                                        type="email"
                                                        name="email"
                                                        value={user.email}
                                                        onChange={formik.handleChange}
                                                        placeholder="Enter email address"
                                                        disabled
                                                    />
                                                </Form.Group>

                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label>Phone Number</Form.Label>
                                                    <Form.Control
                                                        type="tel"
                                                        name="phone"
                                                        value={user.phone}
                                                        onChange={formik.handleChange}
                                                        placeholder="Enter phone number"
                                                        disabled
                                                    />
                                                </Form.Group>

                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label>Type</Form.Label>
                                                    <Form.Select
                                                        className='form-control form-select rounded border-white mb-3 form-input'
                                                        aria-label="Default select example"
                                                        onChange={handleTaskChange}
                                                        value={selectedTask}
                                                    >
                                                        <option value={"1"}>Task</option>
                                                        <option value={"2"}>Other</option>
                                                    </Form.Select>
                                                </Form.Group>

                                                {showTaskDropdown && (
                                                    <Form.Group className="mb-3" controlId="formBasicEmail">
                                                        <Form.Label>Task Name</Form.Label>
                                                        <Form.Select
                                                            className='form-control form-select rounded border-white mb-3 form-input'
                                                            aria-label="Default select example"
                                                            onChange={(e) => handletaskCategory(e)}
                                                            value={assigntask}
                                                            isValid={
                                                                formik.touched.task &&
                                                                !formik.errors.task
                                                            }
                                                            isInvalid={!!formik.errors.task}
                                                        >
                                                            <option value="">Select task name</option>
                                                            {tasks?.map(task =>
                                                                <option value={task?.id}>{task?.title}</option>
                                                            )}
                                                        </Form.Select>
                                                        <Form.Control.Feedback type="invalid">
                                                            {formik.errors.task}
                                                        </Form.Control.Feedback>
                                                    </Form.Group>
                                                )}

                                                <Form.Group className="mb-3" controlId="formBasicEmail">
                                                    <Form.Label>Your Message</Form.Label>
                                                    <Form.Control
                                                        as="textarea"
                                                        name="description"
                                                        isValid={
                                                            formik.touched.description &&
                                                            !formik.errors.description
                                                        }
                                                        isInvalid={!!formik.errors.description}
                                                        value={formik.values.description}
                                                        onChange={formik.handleChange}
                                                        placeholder="Enter your message"
                                                    />
                                                    <Form.Control.Feedback type="invalid">
                                                        {formik.errors.description}
                                                    </Form.Control.Feedback>
                                                </Form.Group>

                                                <div className='text-center'>
                                                    {isloader == true ?
                                                        <div className='loader'>
                                                            <img src={loader} alt="" />
                                                        </div>
                                                        :
                                                        <Button className="submit-button-wrapper" variant="primary" type="submit">
                                                            Submit
                                                        </Button>
                                                    }
                                                </div>

                                            </Form>
                                        </div>

                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </section>
            <Footer />
        </React.Fragment>
    )
}

export default ComplaintForm;